<template>
  <div>
    <v-img 
    v-if="getType() === 'v-img'"
    :src="URL"
    class="elevation-2"
    :width="width"
    :height="height"
    ></v-img>
    <btn-download :url="URL" label="Download" v-if="getType() === 'v-img' && download" noBlock="true"></btn-download>

    <cld-image
      :cloudName="cldConfig.CLOUD_NAME" 
      :public-id="publicID"
      :width="width" 
      :loading="trans.loading || ''" 
      v-if="getType() === 'cld-image'" 
    />

    <div :class="className || ''" v-if="getType() === 'cld-video'">
      <video  
      :id="`cld-player-${videoID}`" 
      :data-cld-public-id="publicID" 
      controls  
      class="cld-video-player cld-fluid">
      </video>
      <btn-download :url="URL" label="Download" v-if="download"></btn-download>
    </div>

    <div :class="className || ''" v-if="getType() === 'video'">
      <div style="text-align:center">
        <video
        class="custom-preview-img"
        id='postVdoMedia'
        :src="URL"
        :width="width"
        :height="height"
        controls>             
            Your browser does not support the video tag.
        </video>
        <btn-download :url="URL" label="Download" :noBlock="true" v-if="download"></btn-download>
      </div>
    </div>

    <iframe 
    :class="className || ''" 
    :width="width"
    :height="height"
    :src="URL" 
    v-if="getType() === 'iframe'" 
    allow="autoplay" 
    scrolling="no" 
    seamless="" 
    allowFullScreen></iframe>

    <gDrive-post-view :url="URL" v-else-if="getType() === 'driveCustomView'" :darkTheme="true" />
  </div>
</template>
<script>
  import config from '@/config';
  import GDrivePostView from '../gdrive/GDrivePostView';
  import BtnDownload from './BtnDownload';
  export default {
    name: 'CustomMedia',
    components: { GDrivePostView, BtnDownload },
    props: [
      'type',
      'publicID',
      'URL',
      'width',
      'height',
      'aspectRatio',
      'trans',
      // 'driveCustomView',
      'videoID',
      'className',
      'styles',
      'download'
    ],
    data() {
      return {
        cldConfig: config.cldConfig,
        cld: null
      }
    },
    mounted() {
      this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
      if (this.type === 'cld-video') {
        setTimeout(() => {
          this.renderCldVideo()
        }, 3000)
      }
    },
    methods: {
      getType: function() {
        if (this.URL.includes('drive.google.com')) {
          if (this.type === 'driveCustomView') {
            return 'driveCustomView'
          }
          return 'iframe'
        }
        return this.type
      },
      renderCldVideo() {
        this.cld.videoPlayer(`cld-player-${this.videoID}`, {});
      }
    }
  }
</script>
<style lang="css" scoped>
.report-video {
  width: 320px;
}
.post-video {
  width: 320px;
  margin: 0 auto;
}
.media-iframe {
  box-sizing: content-box;
  width: 350px;
  border-radius: 2%;
  /* border: 1px solid #fff; */
}
@media (max-width: 767px) {
  .media-iframe {
    width: 290px;
  }
}
</style>



// WEBPACK FOOTER //
// CustomMedia.vue?2a6abd04